import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
axios.defaults.withCredentials = true;

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, obj = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/auth/me`);
        setUser(r.data);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    setUser(r.data);
    return r.data;
  };

  const register = async (email, password, name) => {
    const r = await axios.post(`${API}/auth/register`, { email, password, name });
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch { /* ignore */ }
    setUser(false);
  };

  const refresh = async () => {
    try {
      const r = await axios.get(`${API}/auth/me`);
      setUser(r.data);
      return r.data;
    } catch {
      return null;
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
